@if (data) {
    <cerrix-workspace
        [tabID]="tabID"
        [cerrixTab]="tab"
        [data]="data"
        [headerLookup]="headerLookup"
        [module]="'event'"
        [moduleType]="moduleType"
        [idProp]="'Guid'"
        [permissions]="permissions"
        [filterConfig]="filterConfigs"
        [rendererConfig]="rendererConfig"
        [NumberProperties]="numberProps"
        [DateProperties]="allDateProps"
        (onDblClick)="openDetail($event)"
        (onAddClick)="add()"
        (onServerFiltersApplied)="getData($event)"
    >
    </cerrix-workspace>
}
